import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { MapPin, Plus } from 'lucide-react';
import { cn } from '@/lib/utils';
import { format } from 'date-fns';
import { useState } from "react";
import NewProjectModal from '@/components/NewProjectModal';
import { projectService } from '@/services/projectService';

const statusColors = {
  active: 'bg-success/10 text-success border-success/20',
  completed: 'bg-muted text-muted-foreground border-border',
  planning: 'bg-warning/10 text-warning border-warning/20',
};

const statusLabels = {
  active: 'פעיל',
  completed: 'הושלם',
  planning: 'בתכנון',
};

export default function ProjectsList() {
  const { projects, setProjectsList,logout } = useApp();

  const ProjectsHeader = ({ projects }) => { }
  const [isModalOpen, setIsModalOpen] = useState(false);

  const refreshProjects = () => {
    projectService.getProjects().then((data) => {
      setProjectsList(data);
    }).catch((error) => {
      console.error('Failed to refresh projects:', error);
    })
  }

  return (
    <div className="p-4 md:p-8 space-y-6 animate-fade-in">
      <header className="flex items-center justify-between w-full">
        <div className="w-full mx-auto space-y-1">
          <div className="flex md:flex-row md:items-center justify-between w-full">
            <div className="text-2xl md:text-3xl font-bold">פרויקטים</div>
            <button
              className="mt-3 inline-flex gap-2 px-8 py-2 items-center bg-primary text-primary-foreground rounded-md shadow hover:bg-primary/90"
              onClick={() => {
                setIsModalOpen(!isModalOpen)
                // Open new project modal logic here
              }}
            >
              <Plus className="w-4 h-4" />
              פרויקט חדש
            </button>
          </div>
          <p className="text-muted-foreground">{projects.length} פרויקטים</p>
        </div>
      </header>

      <div className="grid gap-4">
        {projects.map((project, index) => (
          <Link
            key={project.id}
            to={`/projects/${project.id}`}
            className="bg-card rounded-2xl p-5 border border-border shadow-soft hover:border-primary/50 transition-all group animate-slide-up"
            style={{ animationDelay: `${index * 50}ms` }}
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1 min-w-0">
                <h3 className="font-bold text-lg mb-1 truncate group-hover:text-primary transition-colors">
                  {project.name}
                </h3>
                <p className="text-muted-foreground text-sm">{project.clientName}</p>
              </div>
              <span className={cn(
                "px-3 py-1 rounded-full text-xs font-medium border",
                statusColors[project.status]
              )}>
                {statusLabels[project.status]}
              </span>
            </div>

            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3">
              <MapPin className="w-4 h-4 flex-shrink-0" />
              <span className="truncate">{project.address}</span>
            </div>

            <div className="flex items-center justify-between text-sm">
              <div className="flex gap-2">
                {project.tags.map((tag) => (
                  <span key={tag} className="px-2 py-1 bg-secondary rounded-md text-secondary-foreground text-xs">
                    {tag}
                  </span>
                ))}
              </div>
              <span className="text-muted-foreground text-xs">
                עדכון אחרון: {format(new Date(project.lastUpdate), 'd/M')}
              </span>
            </div>
          </Link>
        ))}
      </div>
      {isModalOpen && (
        <NewProjectModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          refreshProjects={refreshProjects}
        />
      )}
    </div>
  );
}
